import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import api from "@/lib/api";
import { photoSrc } from "@/components/funnel/SuccessStories";

const Logo = ({ p }) => {
  const img = (
    <span className="flex h-20 w-40 shrink-0 items-center justify-center rounded-2xl border border-slate-200 bg-white px-4 shadow-sm transition-transform hover:-translate-y-0.5">
      <img src={photoSrc(p.logo_url)} alt={p.name} title={p.name} loading="lazy" className="max-h-12 max-w-full object-contain grayscale transition duration-300 hover:grayscale-0" />
    </span>
  );
  return p.website ? <a href={p.website} target="_blank" rel="noreferrer nofollow" data-testid="logo-wall-item">{img}</a> : <span data-testid="logo-wall-item">{img}</span>;
};

export const LogoWall = ({ className = "pt-24", titleKey = "logoWall.title" }) => {
  const { t } = useTranslation();
  const [logos, setLogos] = useState([]);
  useEffect(() => {
    api.get("/public/partner-logos").then(({ data }) => setLogos(data)).catch(() => {});
  }, []);
  if (!logos.length) return null;
  const scroll = logos.length >= 6;
  return (
    <section className={`mx-auto max-w-7xl px-4 sm:px-6 ${className}`} data-testid="logo-wall">
      <p className="text-center text-sm font-bold uppercase tracking-wider text-slate-500">{t(titleKey, { count: logos.length })}</p>
      {scroll ? (
        <div className="group relative mt-6 overflow-hidden [mask-image:linear-gradient(to_right,transparent,black_8%,black_92%,transparent)]">
          <div className="flex w-max gap-5 animate-[logo-marquee_40s_linear_infinite] group-hover:[animation-play-state:paused]">
            {[...logos, ...logos].map((p, i) => <Logo key={`${p.id}-${i}`} p={p} />)}
          </div>
        </div>
      ) : (
        <div className="mt-6 flex flex-wrap justify-center gap-5">{logos.map((p) => <Logo key={p.id} p={p} />)}</div>
      )}
    </section>
  );
};
